var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"process-bar"},[(_vm.isShowDot)?_c('span',{staticClass:"dot",style:([
      !!_vm.color && {
        backgroundColor: _vm.color
      }
    ])}):_vm._e(),_c('BlockBar',{class:_vm.isShowDot && 'use-dot',attrs:{"items":_vm.processItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }